/* eslint-disable security/detect-unsafe-regex */
/* eslint-disable security/detect-object-injection */
/* eslint-disable max-len */
import React, { useRef } from "react";
import CardHeader from "../../../components/CardHeader";
import LoadingOverlay from "react-loading-overlay-ts";
// import Input from "../../../components/InputBox";
import { useState, useContext, useEffect, useMemo } from "react";
import { useNavigate, useParams } from "react-router-dom";
import Button from "../../../components/Button";
import { validateEmail } from "../../../CommonMethods/EmailValidator";
import ErrorMessage from "../../../components/ErrorMessage";
import GlobalContext from "../../../components/Context/GlobalContext";
import { dataService } from "../../../services/data.services";
import FloatingInput from "../../../components/FloatinInput";
import CardHeaders from "../../../components/CardHeaders";
import StoreCustomize from "./Customization";
import { checkPrivilege } from "../../../CommonMethods/checkPrivilege";
import { setInitial, loadSettings, DEFAULT_CUSTOM_STORE_SETTINGS } from "./Customization/CutomizationSlice";
import { useDispatch, useSelector } from "react-redux";
import { motion } from 'framer-motion';
import { Currencies } from "../../../config/roles";
import Select from 'react-select';
import { countries } from 'country-data-list';
import { isEqual } from 'lodash';;
import { useOnClickOutside } from "../../../CommonMethods/OutsideClick";
export default function AddStores({ edit }) {
    const [allowUpdate, setAllowUpdate] = useState(true);
    const { setToastmessage, setToastErrorMessage, setToastError } = useContext(GlobalContext);
    const [loading, setloading] = useState(false);
    const [invalidEmail, setinvalidEmail] = useState("");
    const [submitSelected, setsubmitSelected] = useState(false);
    const [editData, seteditData] = useState({})
    const [DuplicateItems, setDuplicateItems] = useState([]);
    const [errorState, seterrorState] = useState({});
    const navigate = useNavigate();
    const [error, setError] = useState("");
    const { id, email, merchant_email } = useParams()
    const dispatch = useDispatch();
    const [fonts, setFonts] = useState()
    const [saveModal, setSaveModal] = useState(false)
    const [saveLoading, setSaveLoading] = useState(false)
    const [dropdown, setDropdown] = useState(false)
    const [countryDropdown, setCountryDropdown] = useState(false)
    const [displayCountryName, setDisplayCountryName] = useState('')
    const [countrySearchTerm, setCountrySearchTerm] = useState('')
    const [showCountryClearIcon, setShowCountryClearIcon] = useState(false)
    const customStore = useSelector(state => state.customization);
    const { custom } = customStore;
    const dropdownRef = useRef(null);
    const countryDropdownRef = useRef(null);
    useOnClickOutside(dropdownRef, () => setDropdown(false));
    useOnClickOutside(countryDropdownRef, () => setCountryDropdown(false));

    const [tempCurrency, setTempCurrency] = useState({
        currency: {
            code: '',
            name: '',
            symbol: '',
        },
        gst: '',
    })
    const googleUrl = import.meta.env.VITE_GOOGLE_FONTS_BASE_URL
    const apiKey = import.meta.env.VITE_GOOGLE_API_KEY
    const [state, setState] = useState({
        name: "",
        location: "",
        url: "",
        address: "",
        city: "",
        postal_code: "",
        region: "",
        country: "",
        phone_number: "",
        email_address: "",
        merchant_email_address: merchant_email,
        custom_store_theme: false,
        custom_store_settings: {},
        currency: { "code": "HKD", "name": "Hong Kong Dollar", "symbol": "$" },
        gst: '',
        product_full_image_view: false
    });
    const originalCustomsSetting = DEFAULT_CUSTOM_STORE_SETTINGS

    // Excluded countries list
    const excludedCountries = [
        'Antarctica', 'Bouvet Island', 'Christmas Island', 'Cocos (Keeling) Islands',
        'Comoros', 'Congo', 'Congo, the Democratic Republic of the', 'Cuba','Republic Of Congo','Democratic Republic Of Congo',
        'Falkland Islands (Malvinas)', 'Faroe Islands', 'Iran', 'Iraq', 'Kiribati',
        'Korea, Democratic People\'s Republic Of','Korea, Republic Of','Marshall Islands', 'Mayotte',
        'Micronesia, Federated States of', 'Nauru', 'Netherlands Antilles', 'Niue',
        'Norfolk Island', 'Northern Mariana Islands', 'Palau', 'Pitcairn', 'Réunion',
        'Russia', 'Saint Helena, Ascension and Tristan da Cunha', 'Saint Pierre and and Miquelon',
        'Sao Tome and Principe', 'Somalia', 'South Georgia and the South Sandwich Islands',
        'South Sudan', 'Sudan', 'Svalbard and Jan Mayen', 'Syria', 'Syrian Arab Republic',
        'Tokelau', 'Tuvalu', 'Ukraine', 'Vanuatu', 'Wallis and Futuna', 'Zimbabwe'
    ];

    // Filter countries to exclude unwanted ones and sort alphabetically - using useMemo for performance
    const filteredCountries = useMemo(() => {
        if (!countries?.all || countries.all.length === 0) {
            return [];
        }
        
        // Remove duplicates by alpha2 code and filter excluded countries
        const uniqueCountries = new Map();
        countries.all.forEach(country => {
            if (country && country.name && country.alpha2 && !excludedCountries.includes(country.name)) {
                // Keep the first occurrence of each alpha2 code
                if (!uniqueCountries.has(country.alpha2)) {
                    uniqueCountries.set(country.alpha2, country);
                }
            }
        });
        
        return Array.from(uniqueCountries.values())
            .sort((a, b) => a.name.localeCompare(b.name));
    }, []);

    // Filter countries based on search term - using useMemo for performance
    const filteredCountriesBySearch = useMemo(() => {
        if (!filteredCountries || filteredCountries.length === 0) {
            return [];
        }
        
        if (!countrySearchTerm || countrySearchTerm.trim() === '') {
            return filteredCountries;
        }
        
        const searchLower = countrySearchTerm.toLowerCase().trim();
        return filteredCountries.filter(country => {
            if (!country || !country.name) return false;
            return country.name.toLowerCase().includes(searchLower);
        });
    }, [countrySearchTerm, filteredCountries]);

    const handleCountrySearchChange = (e) => {
        const value = e.target.value;
        setCountrySearchTerm(value);
        setShowCountryClearIcon(value !== '');
    };

    const handleCountrySearchClear = () => {
        setCountrySearchTerm('');
        setShowCountryClearIcon(false);
    };

    const getData = async () => {
        try {
            let res = await dataService.GetAPI(`stores/${email}`);
            seteditData(res.data.data);
            let obj = res?.data?.data;
            obj['product_full_image_view'] = obj?.custom_store_settings?.product_full_image_view;
            if(obj?.custom_store_settings?.product_full_image_view){
                delete res?.data?.data?.custom_store_settings['product_full_image_view']
            }
            
            if (!res?.data?.data?.currency) {
                obj['currency'] = { "code": "HKD", "name": "Hong Kong Dollar", "symbol": "$" }
            }
            if (!res?.data?.data?.gst) {
                obj['gst'] = ''
            }
            setTempCurrency(prev => ({
                ...prev,
                'currency': obj.currency,
                'gst': obj.gst,
            }))
            setState(obj);
            // Set display country name for dropdown
            if (obj.country) {
                //const country = countries.all.find(c => c.alpha2 === obj.country);
                const country = filteredCountries.find(c => c.alpha2 === obj.country);

                if (country) {
                    setDisplayCountryName(country.name);
                }
            }
            // Replaces the draft rather than merging into it, so a previously opened store's
            // colours cannot linger, and resets the undo history to this store's saved values.
            dispatch(loadSettings({
                settings: res?.data?.data?.custom_store_settings,
                custom_store_theme: res?.data?.data?.custom_store_theme,
                product_full_image_view: obj?.product_full_image_view
            }))
        } catch (error) {
            setToastErrorMessage(error.message)
        }

    }
    const getFonts = async () => {
        let res = await dataService.googleFonts(googleUrl, `webfonts?key=${apiKey}`);
        setFonts(res?.data?.items);
    }

    useEffect(() => {
        if (edit) {
            getData()
            getFonts();
            return;
        }
        getFonts();
        dispatch(setInitial())
    }, [])
    const handleValidation = () => {
        const arr = [];
        const mykeys = {
            name: "",
            location: "",
            url: "",
            address: "",
            city: "",
            postal_code: "",
            region: "",
            country: "",
            phone_number: "",
            email_address: "",
            gst: "",
        };
        Object.keys(mykeys).map((item) => {
            if (
                typeof state[item] === "object"
                    ? state[item].length === 0
                    : state[item] === ""
            ) {
                arr.push(item);
            }
        });
        return arr.length === 0;
    };

    const handleInput = (key, value) => {
        setAllowUpdate(true);
        // --- TRIM EMAIL ADDRESSES HERE ---
        if (key === "email_address") {
            setState((prv) => ({
                ...prv,
                [key]: value.trim(), // Trim the value immediately
            }));
        } else {
            setState((prv) => ({
                ...prv,
                [key]: value,
            }));
        }
    };
    const handleSubmit = async (e, key) => {
        // e.preventDefault();
        setloading(true);
        setError("");
        setinvalidEmail("");
        setsubmitSelected(true);
        if (!handleValidation()) {
            setloading(false);
            window.scrollTo(0, 0);
            return;
        }
        if (validateEmail(state.email_address.trim())) {
            setinvalidEmail("Invalid email address");
            setloading(false);
            return;
        }
        if (state?.currency?.code === '') {
            setloading(false);
            return;
        }
        let body = { ...state };
        let customVaribale = body?.custom_store_settings
        if (body?.custom_store_theme) {
            if (JSON.stringify(body?.custom_store_settings) === JSON.stringify(originalCustomsSetting)) {
                setToastError('Customize atleast one section');
                setloading(false);
                return;
            }
        }
        body.gst = Number(body.gst)

        if(!body?.store_logo){
            setToastError('Please upload store logo');
            setloading(false);
            return;       
        }

        try {

            let response;
            if (!body['custom_store_theme']) {
                delete body.custom_store_settings
                delete body['product_full_image_view']
            } else {
                body.custom_store_settings = { ...DEFAULT_CUSTOM_STORE_SETTINGS, ...customVaribale };
                body.custom_store_settings['product_full_image_view'] = state.product_full_image_view
                delete body['product_full_image_view']
            }
            if (edit) {
                delete body._id
                delete body['updated_at']
                delete body['created_at']
                delete body['status']
                delete body['user_type']
                delete body['is_deactivated']



                body['merchant_email_address'] = merchant_email


                response = await dataService.PatchAPI(body, `stores/update/${editData._id}`);

            } else {

                response = await dataService.PostAPI(body, `stores/create`);

            }
            setToastmessage(`${edit ? 'Store details updated' : `Store added`} successfully`);
            navigate(-1);
        } catch (error) {
            setloading(false);
            window.scrollTo(0, 0);
            setToastError(error?.response?.data?.message);
            // setError(error.response.data.message);
        }
    };
    const handleSave = async (e, key) => {
        e.preventDefault();
        setSaveLoading(true);
        setError("");
        setinvalidEmail("");
        setsubmitSelected(true);

        if (!handleValidation()) {
            setSaveLoading(false);
            window.scrollTo(0, 0);
            return;
        }
        if (validateEmail(state.email_address.trim())) {
            setinvalidEmail("Invalid email address");
            setSaveLoading(false);
            return;
        }

        let body = { ...state };
        let customVaribale = body?.custom_store_settings
        if (JSON.stringify(body?.custom_store_settings) === JSON.stringify(originalCustomsSetting)) {
            setToastError('Customize atleast one section');
            setSaveLoading(false);
            return;;
        }
        try {
            let response;
            if (!body['custom_store_theme']) {
                delete body.custom_store_settings
            } else {
                body.custom_store_settings = { ...DEFAULT_CUSTOM_STORE_SETTINGS, ...customVaribale };
            }
            if (edit) {
                delete body._id
                delete body['updated_at']
                delete body['created_at']
                delete body['status']
                delete body['user_type']
                delete body['is_deactivated']

                body['merchant_email_address'] = merchant_email
                response = await dataService.PatchAPI(body, `stores/update/${editData._id}`);

            } else {
                response = await dataService.PostAPI(body, `stores/create`);

            }
            setToastmessage(`${edit ? 'Store details updated' : `Store added`} successfully`);
            setSaveModal(false)
            setSaveLoading(false);
        } catch (error) {
            setSaveLoading(false);
            window.scrollTo(0, 0);
            setToastError(error?.response?.data?.message);
        }
    };
    const popUpHandler = () => {

        setError("");
        setinvalidEmail("");
        setsubmitSelected(true);

        if (!handleValidation()) {
            setSaveLoading(false);
            window.scrollTo(0, 0);
            return;
        }
        if (validateEmail(state.email_address.trim())) {
            setinvalidEmail("Invalid email address");
            setSaveLoading(false);
            return;
        }
        if (state?.currency?.code === '') {
            setloading(false);
            return;
        }
        let body = { ...state };
        if (body?.custom_store_theme) {
            if (JSON.stringify(custom) === JSON.stringify(originalCustomsSetting)) {
                setToastError('Customize atleast one section');
                setSaveLoading(false);
                return;;
            }
        }
        let newCurrency = {
            'currency': body.currency,
            'gst': Number(body.gst)
        }
        if (isEqual(tempCurrency, newCurrency)) {
            handleSubmit();
        } else {
            if(!state?.store_logo){
                setToastError('Please upload store logo');
                setloading(false);
                return;       
            }
            setSaveModal(true);
        }
    }
    const handleToggle = () => {
        if(!state?.custom_store_theme && JSON.stringify(state?.custom_store_settings) === JSON.stringify(originalCustomsSetting)) {
            setAllowUpdate(false);
        } else {
            setAllowUpdate(true);
        }
        setState(prevStore => ({
            ...prevStore,
            custom_store_theme: !prevStore.custom_store_theme
        }));
    }
    const handleGst = (key, value) => {
        // Check if the input is a valid number or a valid number with a decimal point
        if (value === '' || /^-?\d*\.?\d{0,2}$/.test(value)) {
            // Convert value to a number
            const numericValue = Number(value);

            // Only update state if the value is valid and less than 100 or if it's an empty string
            if (value === '' || (!isNaN(numericValue) && numericValue < 100)) {
                setAllowUpdate(true);
                setState(prevStore => ({
                    ...prevStore,
                    [key]: value,
                }));
            }
        }
    }

    const hasCustomizePrivilege = checkPrivilege('change_store_customization')
    return (
        <CardHeaders
            header={edit ? "Edit Store" : "Add Store"}
            paths={["Merchant List", "Merchant Details"]}
            activePath={edit ? ['Edit Store'] : ['Add Store']}
            pathurls={['/manage-merchants', `/${merchant_email}/view`]}
            //back={`/manage-merchants/${id1}/view`}
            back={-1}

        >
            <LoadingOverlay active={edit ? Object.keys(editData).length === 0 : false} spinner text="Fetching Store details...">
                <div className="bg-[#f5f5f5] w-full p-[14px]">
                    <div className="bg-white px-4 h-customh10 overflow-y-scroll scrollHide">
                        <div className=" pt-8 pb-6 pl-5">
                            <p className=" text-xl font-medium text-[#4B4B4B]">
                                Store Details
                            </p>
                        </div>
                        <div>
                            <div className="pt-4 pl-5 pb-3 rounded-[4px]">
                                <div className="flex mb-6 -mx-3 ">
                                    <div className="w-1/3 px-3">
                                        <div className="relative">
                                            <FloatingInput
                                                submitSelected={submitSelected}
                                                setsubmitSelected={setsubmitSelected}
                                                value={state.name}
                                                id="name"
                                                handleInput={handleInput}
                                                state={state.name}
                                                classKey={`${submitSelected && state.name === ""
                                                    ? "input-error"
                                                    : "input-border"
                                                    // eslint-disable-next-line max-len
                                                } w-full px-4 rounded h-[56px] focus:outline-none focus:ring-0 focus:border-[#333232] peer`}
                                                labelCalss={`${submitSelected && (state.name === '' || (errorState['name'] && errorState['name'] !== '')) ? 'text-[#FC4523] ' : 'text-[#1F1F1F]'} px-4 absolute text-[#1F1F1F] block font-semibold text-sm duration-300 transform -translate-y-4 scale-75 top-4 z-10 origin-[0] left-1 peer-focus:text-[#1F1F1F]  peer-focus:dark: peer-placeholder-shown:scale-100 peer-placeholder-shown:translate-y-0 peer-focus:scale-75 peer-focus:-translate-y-4`}
                                                // errorImage="email-error.svg"
                                                // normalImage="email.svg"
                                                text="Store name"
                                                errorState={errorState}
                                                placeholder={edit ? ' ' : ''}
                                            />
                                        </div>
                                    </div>
                                    <div className="w-1/3 px-3">
                                        <div className="relative">
                                            <FloatingInput
                                                setsubmitSelected={setsubmitSelected}
                                                submitSelected={submitSelected}
                                                value={state.email_address}
                                                id="email_address"
                                                handleInput={handleInput}
                                                state={state.email_address}
                                                classKey={`${submitSelected &&
                                                    (state.email_address === "" ||
                                                        validateEmail(state.email_address.trim()) || error)
                                                    ? "input-error"
                                                    : "input-border"
                                                } ${edit ? 'text-[#ABABAB]' : '[#1F1F1F]'} w-full px-4 rounded h-[56px] focus:outline-none focus:ring-0 focus:border-[#333232] peer`}
                                                labelCalss={`${submitSelected &&
                                                    (state.email_address === "" ||
                                                        validateEmail(state.email_address.trim()) || error)
                                                    ? 'text-[#FC4523] ' : 'text-[#1F1F1F]'} ${edit ? 'text-[#ABABAB]' : '[#1F1F1F]'} px-4 absolute text-[#1F1F1F] block font-semibold text-sm duration-300 transform -translate-y-4 scale-75 top-4 z-10 origin-[0] left-1 peer-focus:text-[#1F1F1F]  peer-focus:dark: peer-placeholder-shown:scale-100 peer-placeholder-shown:translate-y-0 peer-focus:scale-75 peer-focus:-translate-y-4`}
                                                // errorImage="email-error.svg"
                                                // normalImage="email.svg"
                                                text={edit ? "Email address" : "Store manager email address"}
                                                errorState={errorState}
                                                placeholder={edit ? ' ' : ''}
                                                disabled={edit}
                                                readonly={edit}

                                            />
                                            {submitSelected &&
                                                state.email_address !== "" &&
                                                validateEmail(
                                                    state.email_address || invalidEmail !== "") && (<ErrorMessage message="Invalid email address" error />
                                            )}
                                            {submitSelected && error !== "" && (
                                                <ErrorMessage message={error} error />
                                            )}
                                        </div>
                                    </div>
                                    <div className="w-1/3 px-3">
                                        <div className=" relative">
                                            <FloatingInput
                                                setsubmitSelected={setsubmitSelected}
                                                submitSelected={submitSelected}
                                                value={state.phone_number}
                                                id="phone_number"
                                                handleInput={handleInput}
                                                state={state.phone_number}
                                                classKey={`${submitSelected && state.phone_number === ""
                                                    ? "input-error"
                                                    : "input-border"
                                                    // eslint-disable-next-line max-len
                                                } w-full px-4 rounded h-[56px] focus:outline-none focus:ring-0 focus:border-[#333232] peer`}
                                                labelCalss={`${submitSelected && (state.phone_number === '' || (errorState['phone_number'] && errorState['phone_number'] !== '')) ? 'text-[#FC4523] ' : 'text-[#1F1F1F]'} px-4 absolute text-[#1F1F1F] block font-semibold text-sm duration-300 transform -translate-y-4 scale-75 top-4 z-10 origin-[0] left-1 peer-focus:text-[#1F1F1F]  peer-focus:dark: peer-placeholder-shown:scale-100 peer-placeholder-shown:translate-y-0 peer-focus:scale-75 peer-focus:-translate-y-4`}
                                                // errorImage="email-error.svg"
                                                // normalImage="email.svg"
                                                text="Phone number"
                                                inputType="number"
                                                errorState={errorState}
                                                placeholder={edit ? ' ' : ''}
                                            />
                                        </div>
                                    </div>

                                </div>
                                <div className="flex -mx-3 mb-6">
                                    <div className="w-1/3 px-3">
                                        <div className="relative">

                                            <FloatingInput
                                                setsubmitSelected={setsubmitSelected}
                                                submitSelected={submitSelected}
                                                value={state.address}
                                                id="address"
                                                handleInput={handleInput}
                                                state={state.address}
                                                classKey={`${submitSelected && state.address === ""
                                                    ? "input-error"
                                                    : "input-border"
                                                    // eslint-disable-next-line max-len
                                                } w-full px-4 rounded h-[56px] focus:outline-none focus:ring-0 focus:border-[#333232] peer`}
                                                labelCalss={`${submitSelected && (state.address === '' || (errorState['address'] && errorState['address'] !== '')) ? 'text-[#FC4523] ' : 'text-[#1F1F1F]'} px-4 absolute text-[#1F1F1F] block font-semibold text-sm duration-300 transform -translate-y-4 scale-75 top-4 z-10 origin-[0] left-1 peer-focus:text-[#1F1F1F]  peer-focus:dark: peer-placeholder-shown:scale-100 peer-placeholder-shown:translate-y-0 peer-focus:scale-75 peer-focus:-translate-y-4`}
                                                // errorImage="email-error.svg"
                                                // normalImage="email.svg"
                                                text="Address"
                                                placeholder={edit ? ' ' : ''}
                                                errorState={errorState}
                                            />
                                        </div>
                                    </div>
                                    <div className="w-1/3 px-3">
                                        <div className="relative">
                                            <FloatingInput
                                                submitSelected={submitSelected}
                                                setsubmitSelected={setsubmitSelected}
                                                value={state.location}
                                                id="location"
                                                handleInput={handleInput}
                                                state={state.location}
                                                classKey={`${submitSelected && state.location === ""
                                                    ? "input-error"
                                                    : "input-border"
                                                    // eslint-disable-next-line max-len
                                                } w-full px-4 rounded h-[56px] focus:outline-none focus:ring-0 focus:border-[#333232] peer`}
                                                labelCalss={`${submitSelected && (state.location === '' || (errorState['location'] && errorState['location'] !== '')) ? 'text-[#FC4523] ' : 'text-[#1F1F1F]'} px-4 absolute text-[#1F1F1F] block font-semibold text-sm duration-300 transform -translate-y-4 scale-75 top-4 z-10 origin-[0] left-1 peer-focus:text-[#1F1F1F]  peer-focus:dark: peer-placeholder-shown:scale-100 peer-placeholder-shown:translate-y-0 peer-focus:scale-75 peer-focus:-translate-y-4`}
                                                // errorImage="email-error.svg"
                                                // normalImage="email.svg"
                                                text="Location"
                                                errorState={errorState}
                                                placeholder={edit ? ' ' : ''}
                                            />
                                        </div>
                                    </div>
                                    <div className="w-1/3 px-3">
                                        <div className="relative">
                                            <FloatingInput
                                                setsubmitSelected={setsubmitSelected}
                                                submitSelected={submitSelected}
                                                value={state.city}
                                                id="city"
                                                handleInput={handleInput}
                                                state={state.city}
                                                classKey={`${submitSelected && state.city === ""
                                                    ? "input-error"
                                                    : "input-border"
                                                    // eslint-disable-next-line max-len
                                                } w-full px-4 rounded h-[56px]  focus:outline-none focus:ring-0 focus:border-[#333232] peer`}
                                                labelCalss={`${submitSelected && (state.city === '' || (errorState['city'] && errorState['city'] !== '')) ? 'text-[#FC4523] ' : 'text-[#1F1F1F]'} px-4 absolute text-[#1F1F1F] block font-semibold text-sm duration-300 transform -translate-y-4 scale-75 top-4 z-10 origin-[0] left-1 peer-focus:text-[#1F1F1F]  peer-focus:dark: peer-placeholder-shown:scale-100 peer-placeholder-shown:translate-y-0 peer-focus:scale-75 peer-focus:-translate-y-4`}
                                                // errorImage="email-error.svg"
                                                // normalImage="email.svg"
                                                text="City"
                                                placeholder={edit ? ' ' : ''}
                                                errorState={errorState}
                                            />
                                        </div>
                                    </div>

                                </div>
                                <div className="flex -mx-3 mb-6">
                                    <div className="px-3 w-1/3">
                                        <div className="relative">

                                            <FloatingInput
                                                setsubmitSelected={setsubmitSelected}
                                                submitSelected={submitSelected}
                                                value={state.postal_code}
                                                id="postal_code"
                                                handleInput={handleInput}
                                                state={state.postal_code}
                                                classKey={`${submitSelected && state.postal_code === ""
                                                    ? "input-error"
                                                    : "input-border"
                                                    // eslint-disable-next-line max-len
                                                } w-full px-4 rounded h-[56px] focus:outline-none focus:ring-0 focus:border-[#333232] peer`}
                                                labelCalss={`${submitSelected && (state.postal_code === '' || (errorState['postal_code'] && errorState['postal_code'] !== '')) ? 'text-[#FC4523] ' : 'text-[#1F1F1F]'} px-4 absolute text-[#1F1F1F] block font-semibold text-sm duration-300 transform -translate-y-4 scale-75 top-4 z-10 origin-[0] left-1 peer-focus:text-[#1F1F1F]  peer-focus:dark: peer-placeholder-shown:scale-100 peer-placeholder-shown:translate-y-0 peer-focus:scale-75 peer-focus:-translate-y-4`}
                                                // errorImage="email-error.svg"
                                                // normalImage="email.svg"
                                                text="Postal code"
                                                placeholder={edit ? ' ' : ''}
                                                errorState={errorState}
                                            />
                                        </div>
                                    </div>
                                    <div className="px-3 w-1/3">
                                        <div className="relative">
                                            <FloatingInput
                                                setsubmitSelected={setsubmitSelected}
                                                submitSelected={submitSelected}
                                                value={state.region}
                                                id="region"
                                                handleInput={handleInput}
                                                state={state.region}
                                                maxLength={50}
                                                minLength={2}
                                                classKey={`${submitSelected && state.region === ""
                                                    ? "input-error"
                                                    : "input-border"
                                                    // eslint-disable-next-line max-len
                                                } w-full px-4 rounded h-[56px] focus:outline-none focus:ring-0 focus:border-[#333232] peer `}
                                                labelCalss={`${submitSelected && (state.region === '' || (errorState['region'] && errorState['region'] !== '')) ? 'text-[#FC4523] ' : 'text-[#1F1F1F]'} px-4 absolute text-[#1F1F1F] block font-semibold text-sm duration-300 transform -translate-y-4 scale-75 top-4 z-10 origin-[0] left-1 peer-focus:text-[#1F1F1F]  peer-focus:dark: peer-placeholder-shown:scale-100 peer-placeholder-shown:translate-y-0 peer-focus:scale-75 peer-focus:-translate-y-4`}
                                                // errorImage="email-error.svg"
                                                // normalImage="email.svg"
                                                text="State/Region"
                                                placeholder={edit ? ' ' : ''}
                                                errorState={errorState}
                                            />
                                        </div>
                                        <p className="text-xs text-gray-500 mb-2">
                                            <span className="font-bold">Note:</span>  For U.S. states and Canadian provinces, please use the standard 2-letter abbreviations (e.g., CA for California, ON for Ontario).
                                        </p>
                                    </div>
                                    <div className="px-3 w-1/3">
                                        <div className='w-full bg-white'>
                                            <div className="dropdown" ref={countryDropdownRef}>
                                                <div className={`w-full relative`}>
                                                    <div className='relative w-full'>
                                                        <input
                                                            type="text"
                                                            className={`${submitSelected && state.country === "" ? "input-error" : "input-border"} peer m-0 block pt-1 h-[58px] w-full cursor-pointer rounded border border-solid border-neutral-300 bg-transparent bg-clip-padding px-3 text-[15px] font-normal leading-tight text-black transition duration-200 ease-linear placeholder:text-transparent focus:text-black focus:outline-none peer-focus:text-black dark:border-neutral-600 dark:text-black dark:focus:border-primary dark:peer-focus:text-primary`}
                                                            id="country"
                                                            data-testid="country-dropdown"
                                                            placeholder=" "
                                                            onClick={() => {
                                                                setsubmitSelected(false);
                                                                const newDropdownState = !countryDropdown;
                                                                setCountryDropdown(newDropdownState);
                                                                if (newDropdownState) {
                                                                    setCountrySearchTerm('');
                                                                    setShowCountryClearIcon(false);
                                                                }
                                                            }}
                                                            value={displayCountryName || ''}
                                                            readOnly
                                                        />
                                                        <label htmlFor="country" className={`${submitSelected && state.country === '' ? 'text-[#FC4523] ' : 'text-[#1F1F1F]'} px-3 absolute text-[#1F1F1F] block font-semibold text-sm duration-300 transform -translate-y-4 scale-75 top-[18px] z-5 origin-[0] left-1 peer-focus:text-[#1F1F1F] peer-focus:dark: peer-placeholder-shown:scale-100 peer-placeholder-shown:translate-y-0 ${state.country === '' ? 'text-sm font-semibold' : 'text-sm font-semibold peer-focus:-translate-y-4 peer-focus:scale-75'}`}>Country</label>
                                                        <motion.img
                                                            animate={{ rotate: countryDropdown === true ? 180 : 0 }}
                                                            src={`${submitSelected && state.country === '' ? '/assets/images/error-chevron-down.svg' : '/assets/images/chevron-down.svg'}`}
                                                            alt=""
                                                            className="absolute top-4 right-5 cursor-pointer"
                                                            onClick={() => {
                                                                setsubmitSelected(false);
                                                                const newDropdownState = !countryDropdown;
                                                                setCountryDropdown(newDropdownState);
                                                                if (newDropdownState) {
                                                                    setCountrySearchTerm('');
                                                                    setShowCountryClearIcon(false);
                                                                }
                                                            }}
                                                        />
                                                        {submitSelected && state.country === '' && <p className="text-sm font-normal text-[#FC4523] mt-[8px]">This field is mandatory</p>}
                                                    </div>
                                                    <ul className={`dropdown-menu absolute scrollBar w-full border border-b-[#DDDDDD]  z-[100] max-h-[322px] mt-1 overflow-y-auto bg-white ${countryDropdown ? 'show' : 'hidden'}`}>
                                                        {/* Search bar */}
                                                        <li className="sticky top-0 bg-white z-10 w-full px-4 py-2 rounded-[2px]">
                                                            <div className="flex items-center justify-between relative">
                                                                <input
                                                                    type="text"
                                                                    data-testid="country-search"
                                                                    className="flex-grow w-full pl-3 pr-9 py-[11px] border border-black text-xs font-normal text-black rounded-md outline-0 placeholder:text-xs placeholder:text-[#1F1F1F] placeholder:font-normal"
                                                                    placeholder="Country Name"
                                                                    value={countrySearchTerm}
                                                                    maxLength={50}
                                                                    onChange={handleCountrySearchChange}
                                                                    onClick={(e) => e.stopPropagation()}
                                                                    onFocus={(e) => e.stopPropagation()}
                                                                />
                                                                {showCountryClearIcon ? (
                                                                    <button 
                                                                        type="button"
                                                                        data-testid="country-clear-btn" 
                                                                        onClick={(e) => {
                                                                            e.stopPropagation();
                                                                            handleCountrySearchClear();
                                                                        }} 
                                                                        className="absolute  right-[18px] top-[50%] transform -translate-y-1/2"
                                                                    >
                                                                        <img src="/assets/images/close-icon.svg" alt='Clear' />
                                                                    </button>
                                                                ) : (
                                                                    <img 
                                                                        src="/assets/images/search1.svg" 
                                                                        alt='' 
                                                                        className='absolute right-[18px] top-[12px]' 
                                                                    />
                                                                )}
                                                            </div>
                                                        </li>
                                                        {/* Country list */}
                                                        {filteredCountriesBySearch && filteredCountriesBySearch.length > 0 ? filteredCountriesBySearch.map((country, index) => (
                                                            <li
                                                                key={`${country?.alpha2}-${index}`}
                                                                onClick={() => {
                                                                    handleInput('country', country.alpha2)
                                                                    setDisplayCountryName(country.name)
                                                                    setCountryDropdown(false)
                                                                    setCountrySearchTerm('')
                                                                    setShowCountryClearIcon(false)
                                                                }}
                                                                data-testid={`country-${index}`}
                                                                className="dropdown-item cursor-pointer w-full px-4 py-4 border border-[#DDDDDD] hover:bg-[#EB9DC7] rounded-[2px] text-sm font-semibold text-[#1F1F1F] overflow-hidden text-ellipsis whitespace-nowrap"
                                                            >
                                                                {country.name}
                                                            </li>
                                                        )) : (
                                                            <li className='border border-[#DDDDDD] h-[200px] flex flex-col justify-center items-center px-4'>
                                                                {countrySearchTerm ? (
                                                                    <>
                                                                        <img src="/assets/images/No-search.gif" alt="No search results" className="" />
                                                                        <p className="text-sm text-[#1F1F1F] text-center leading-relaxed mb-8">We {"couldn't"} find what you searched for. Please try a different search or try again</p>
                                                                    </>
                                                                ) : (
                                                                    'No countries available yet.'
                                                                )}
                                                            </li>
                                                        )}
                                                    </ul>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                <div className="flex -mx-3 mb-6">
                                    <div className="px-3 w-1/3">
                                        <div className="relative">
                                            <FloatingInput
                                                setsubmitSelected={setsubmitSelected}
                                                submitSelected={submitSelected}
                                                value={state.url}
                                                id="url"
                                                handleInput={handleInput}
                                                state={state.url}
                                                classKey={`${submitSelected && state.url === ""
                                                    ? "input-error"
                                                    : "input-border"
                                                    // eslint-disable-next-line max-len
                                                } w-full px-4 rounded h-[56px] focus:outline-none focus:ring-0 focus:border-[#333232] peer`}
                                                labelCalss={`${submitSelected && (state.url === '' || (errorState['url'] && errorState['url'] !== '')) ? 'text-[#FC4523] ' : 'text-[#1F1F1F]'} px-4 absolute text-[#1F1F1F] block font-semibold text-sm duration-300 transform -translate-y-4 scale-75 top-4 z-10 origin-[0] left-1 peer-focus:text-[#1F1F1F]  peer-focus:dark: peer-placeholder-shown:scale-100 peer-placeholder-shown:translate-y-0 peer-focus:scale-75 peer-focus:-translate-y-4`}
                                                // errorImage="email-error.svg"
                                                // normalImage="email.svg"
                                                text="URL"
                                                errorState={errorState}
                                                placeholder={edit ? ' ' : ''}

                                            />
                                        </div>
                                    </div>
                                    <div className="px-3 w-1/3">
                                        <div className='w-full bg-white '>
                                            <div className="dropdown"
                                                ref={dropdownRef}
                                            >
                                                <div className={`w-full relative`} >
                                                    <div className='relative w-full'>
                                                        <input
                                                            type="text"
                                                            className={`${submitSelected && (state['currency']?.code === "" || !state['currency']?.code) ? "input-error" : "input-border"} peer m-0 block pt-1 h-[58px] w-full cursor-pointer rounded border border-solid border-neutral-300 bg-transparent bg-clip-padding px-3 text-[15px] font-normal leading-tight text-black transition duration-200 ease-linear placeholder:text-transparent  focus:text-black focus:outline-none peer-focus:text-black dark:border-neutral-600 dark:text-black  dark:focus:border-primary dark:peer-focus:text-primary`}
                                                            id={`currency`}
                                                            data-testid={`currency-dropdown`}
                                                            placeholder=" "
                                                            onClick={() => {
                                                                setsubmitSelected(false);
                                                                setDropdown(!dropdown)
                                                            }}
                                                            value={`${state['currency']?.code} - ${state['currency']?.name}` || ''}
                                                            readOnly
                                                        />
                                                        <label htmlFor={`currency`} className={`${submitSelected && (state['currency']?.code === '' || !state['currency']?.code) ? 'text-[#FC4523] ' : 'text-[#1F1F1F]'} px-3 absolute text-[#1F1F1F] block duration-300 transform -translate-y-4 scale-75 top-[18px] z-5 origin-[0] left-1 peer-focus:text-[#1F1F1F]  peer-focus:dark: peer-placeholder-shown:scale-100 peer-placeholder-shown:translate-y-0 ${state['currency']?.code === '' || !state['currency']?.code ? 'text-sm font-semibold' : 'text-sm font-semibold peer-focus:-translate-y-4 peer-focus:scale-75'} `}>Currency</label>

                                                        <motion.img
                                                            animate={{ rotate: dropdown === true ? 180 : 0 }}
                                                            src={`${submitSelected && (state['currency']?.code === '' || !state['currency']?.code) ? '/assets/images/error-chevron-down.svg' : '/assets/images/chevron-down.svg'}`}
                                                            alt=""
                                                            className="absolute top-4 right-5 cursor-pointer"
                                                            onClick={() => {
                                                                setsubmitSelected(false)
                                                                setDropdown(!dropdown)
                                                            }}
                                                        />
                                                        {submitSelected && (state['currency']?.code === '' || !state['currency']?.code) && <p className="text-sm font-normal text-[#FC4523] mt-[8px]">This field  is mandatory</p>}

                                                    </div>
                                                    {
                                                        <ul className={`dropdown-menu absolute scrollBar w-full z-[100] max-h-[162px] mt-1 overflow-y-auto bg-white ${dropdown ? 'show' : 'hidden'}`}>
                                                            {Currencies && Currencies?.length > 0 ? Currencies.map((currency, index) => (

                                                                <li
                                                                    key={currency?.code}
                                                                    onClick={() => {
                                                                        handleInput('currency', currency)
                                                                        setDropdown(false)
                                                                    }}
                                                                    data-testid={`currency-${index}`}
                                                                    // eslint-disable-next-line max-len
                                                                    className="dropdown-item cursor-pointer w-full px-4 py-4 border border-[#DDDDDD] hover:bg-[#EB9DC7] rounded-[2px] text-sm font-semibold text-[#1F1F1F] overflow-hidden text-ellipsis whitespace-nowrap"
                                                                >
                                                                    {`${currency?.code} - ${currency?.name}`}
                                                                </li>

                                                            )

                                                            ) :
                                                                (<div className='border border-[#DDDDDD] h-[100px] flex justify-center items-center'>
                                                                    No currency available yet.
                                                                </div>)

                                                            }

                                                        </ul>
                                                    }

                                                </div>
                                            </div>
                                        </div></div>

                                </div>
                                <div className="flex -mx-3 mb-6">
                                    <div className="px-3 w-1/3">
                                        <div className="relative">
                                            <FloatingInput
                                                setsubmitSelected={setsubmitSelected}
                                                submitSelected={submitSelected}
                                                value={state.gst}
                                                id="gst"
                                                handleInput={handleGst}
                                                state={state.gst}
                                                classKey={`${submitSelected && state.gst === ""
                                                    ? "input-error"
                                                    : "input-border"
                                                    // eslint-disable-next-line max-len
                                                } w-full px-4 rounded h-[56px] focus:outline-none focus:ring-0 focus:border-[#333232] peer`}
                                                labelCalss={`${submitSelected && (state.gst === '' || (errorState['gst'] && errorState['gst'] !== '')) ? 'text-[#FC4523] ' : 'text-[#1F1F1F]'} pl-4 pr-[32px] absolute text-[#1F1F1F] block font-semibold text-sm duration-300 transform -translate-y-4 scale-75 top-4 z-10 origin-[0] left-1 peer-focus:text-[#1F1F1F]  peer-focus:dark: peer-placeholder-shown:scale-100 peer-placeholder-shown:translate-y-0 peer-focus:scale-75 peer-focus:-translate-y-4`}
                                                // errorImage="email-error.svg"
                                                // normalImage="email.svg"
                                                text="GST"
                                                errorState={errorState}
                                                placeholder={edit ? ' ' : ''}

                                            />
                                            <p className={`absolute ${submitSelected && (state.gst === '' || (errorState['gst'] && errorState['gst'] !== '')) ? 'text-[#FC4523] ' : 'text-[#1f1f1f]'} top-4 right-4`}>%</p>
                                        </div>

                                    </div>
                                </div>
                            </div>
                        </div>

                        {/* customization starts here*/}
                        {hasCustomizePrivilege && <div className="pl-5 ">
                            <h1 className='font-playfair font-medium text-xl text-[#4B4B4B]'>Store Customization</h1>
                            <div class="status custom-toggle flex items-center mt-[22px] mb-5" >
                                <label class="switch" style={{ marginLeft: "" }}>
                                    <input type="checkbox" id="clock_in_out" checked={state?.custom_store_theme === true ? true : false} />
                                    <span data-testid={`toggle-btn`} class={`slider round cursor-pointer`} onClick={handleToggle}></span>
                                </label>
                                <p className="text-black text-sm font-normal ml-3">{state?.custom_store_theme ? 'Custom store theme' : 'Default store theme'}</p>
                            </div>
                            <StoreCustomize
                                fonts={fonts}
                                state={state}
                                setState={setState}
                                edit={edit}
                                saveModal={saveModal}
                                setSaveModal={setSaveModal}
                                handleSubmit={handleSubmit}
                                setAllowUpdate={setAllowUpdate}
                                popUpHandler={popUpHandler}
                                saveLoading={saveModal ? loading : ''}
                            />
                        </div>}
                        {/* customization ends here  */}
                        <div className="pl-5 mt-[38px]">
                            <Button
                                handleClick={edit ? popUpHandler : handleSubmit}
                                loading={!saveModal ? loading : ''}
                                disabled={loading || !allowUpdate}
                                text={edit ? "Update" : "Add"}
                                classKey={`${!allowUpdate ? 'opacity-30' : 'opacity-1'} w-1/3 px-4 py-[10px] bg-primary rounded-[12px] text-white text-lg font-bold mb-4`}
                                type="submit"
                                testId="addstore"
                            />
                        </div>
                    </div>
                </div>
            </LoadingOverlay>
        </CardHeaders>
    );
}
